import { Asterisk } from "lucide-react";

export default function Marquee({ items }) {
  return (
    <div className="overflow-hidden border-y border-slate-200 bg-white py-5" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center">
            {items.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center whitespace-nowrap">
                <span className="px-6 text-sm font-semibold uppercase tracking-[0.22em] text-slate-400">
                  {item}
                </span>
                <Asterisk className="h-4 w-4 text-indigo-400" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
